export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      name: '登录'
    },
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    meta: {
      name: '重置密码'
    },
    component: () => import('@/views/register/reset-password.vue')
  },
  {
    path: '/',
    component: () => import('@/views/index/home.vue'),
    children: [
      {
        path: 'query',
        name: 'query',
        meta: {
          title: '融资查询',
          keepAlive: true
        },
        component: () => import('@/views/finance/finance-query.vue')
      },
      {
        path: 'detail',
        name: 'detail',
        meta: {
          title: '融资详情'
        },
        component: () => import('@/views/finance/finance-detail.vue')
      },
      {
        path: 'invoice-query',
        name: 'invoice-query',
        meta: {
          title: '开票信息管理'
        },
        component: () => import('@/views/finance/invoice-query.vue')
      }
    ]
  }
]